// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box_top_popClass{font-size:12px;padding:12px 16px;justify-content:space-between}.contactPopper{max-height:400px;overflow-y:auto;padding:0}", ""]);
// Exports
module.exports = exports;
